// extracted by css-extract-rspack-plugin
export default {"wrapper":"_1f597150","groupedCreatorsWrapper":"_61be7dc1"};